module.exports = __webpack_public_path__ + "img/LogoUbuken_Gris.78009bc2.png";